var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import Skeleton from '../../../core/components/Skeleton';
import { SIZES } from '../../../core/hocs/withSize';
export const AvatarContainer = styled((_a) => {
    var { backgroundImage, children, loading, size } = _a, props = __rest(_a, ["backgroundImage", "children", "loading", "size"]);
    return (React.createElement("div", Object.assign({}, props), loading ? (React.createElement(Skeleton, { circle: true, width: "100%", height: "100%", style: { display: 'block' } })) : (children)));
}) `
  position: relative;
  flex-shrink: 0;
  overflow: hidden;

  ${({ size, backgroundImage, theme }) => `
    height: ${SIZES[size]}px;
    width: ${SIZES[size]}px;
    background: ${backgroundImage || theme.palette.base.shade3}};
  `};

  border-radius: 50%;

  &.visible img {
    opacity: 1;
  }

  &.clickable {
    &:hover {
      cursor: pointer;
    }
  }
`;
export const AvatarOverlay = styled.div `
  position: absolute;
  z-index: 2;
  opacity: 0.5;
  background-color: #000000;

  ${({ size }) => `
    height: ${SIZES[size]}px;
    width: ${SIZES[size]}px;
  `}
`;
export const Img = styled.img.attrs({ loading: 'lazy' }) `
  height: 100%;
  width: 100%;
  object-fit: cover;
  opacity: 0;
  transition: opacity 0.3s;
`;
export const FileInput = styled.input.attrs({ type: 'file' }) `
  &&& {
    display: none;
  }
`;
export const Label = styled.label ``;
//# sourceMappingURL=styles.js.map